'use client'

import { createContext } from 'react'
import type { ResolvedExperiment } from '@/core/Experiment'

type ContextType = Array<ResolvedExperiment>

export const ExperimentsContext = createContext<ContextType | null>(null)

export function ExperimentsContextProvider({
  experiments,
  children,
}: {
  experiments: ContextType
  children: React.ReactNode
}) {
  return (
    <ExperimentsContext.Provider value={experiments}>
      {children}
    </ExperimentsContext.Provider>
  )
}
